export type ProblemAnswerScrollAnchor = "top" | "bottom";

type ScrollRestoreBrowser = Pick<Window, "requestAnimationFrame" | "scrollBy">;
type ScrollAnchorElement = Pick<Element, "getBoundingClientRect"> &
  Partial<Pick<Element, "isConnected">>;
type ScrollRestoreOptions = {
  behavior?: ScrollBehavior;
  browser?: ScrollRestoreBrowser;
};

const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export function getInlineSolutionCollapseScrollBehavior(
  browser: Pick<Window, "matchMedia"> = window,
): ScrollBehavior {
  return browser.matchMedia(REDUCED_MOTION_QUERY).matches ? "auto" : "smooth";
}

export function getProblemAnswerScrollAnchorPosition(
  element: ScrollAnchorElement,
  anchor: ProblemAnswerScrollAnchor,
): number {
  const rect = element.getBoundingClientRect();
  return anchor === "bottom" ? rect.bottom : rect.top;
}

export function restoreProblemAnswerScrollPosition(
  element: ScrollAnchorElement,
  anchor: ProblemAnswerScrollAnchor,
  previousPosition: number,
  options: ScrollRestoreOptions = {},
): void {
  const { behavior = "auto", browser = window } = options;

  browser.requestAnimationFrame(() => {
    if (element.isConnected === false) return;

    const nextPosition = getProblemAnswerScrollAnchorPosition(element, anchor);
    const scrollOffset = nextPosition - previousPosition;

    if (!Number.isFinite(scrollOffset) || scrollOffset === 0) return;

    if (behavior === "smooth") {
      browser.scrollBy({ top: scrollOffset, behavior });
      return;
    }

    browser.scrollBy(0, scrollOffset);
  });
}
